"use client";
import { jsx as A, Fragment as ut, jsxs as Oe } from "react/jsx-runtime";
import { cn as Ne } from "./utils/cn.js";
import * as s from "react";
import h, { useState as Jn, useMemo as er, useLayoutEffect as tr, useEffect as nr, memo as rr } from "react";
import { r as or, R as ar } from "./index-Bj0JPdDq.js";
import { stylesModal as ve } from "./components/modals/styles.js";
function oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function xt(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Xt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = xt(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : xt(e[o], null);
        }
      };
  };
}
function ce(...e) {
  return s.useCallback(Xt(...e), e);
}
function ir(e, t) {
  const n = s.createContext(t), r = (a) => {
    const { children: u, ...i } = a, f = s.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ A(n.Provider, { value: f, children: u });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const u = s.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function sr(e, t = []) {
  let n = [];
  function r(a, u) {
    const i = s.createContext(u), f = n.length;
    n = [...n, u];
    const l = (d) => {
      var p;
      const { scope: m, children: b, ...T } = d, c = ((p = m == null ? void 0 : m[e]) == null ? void 0 : p[f]) || i, y = s.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ A(c.Provider, { value: y, children: b });
    };
    l.displayName = a + "Provider";
    function v(d, m) {
      var c;
      const b = ((c = m == null ? void 0 : m[e]) == null ? void 0 : c[f]) || i, T = s.useContext(b);
      if (T) return T;
      if (u !== void 0) return u;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return [l, v];
  }
  const o = () => {
    const a = n.map((u) => s.createContext(u));
    return function(i) {
      const f = (i == null ? void 0 : i[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: f } }),
        [i, f]
      );
    };
  };
  return o.scopeName = e, [r, ur(o, ...t)];
}
function ur(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const u = r.reduce((i, { useScope: f, scopeName: l }) => {
        const d = f(a)[`__scope${l}`];
        return { ...i, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Ue = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, cr = s.useId || (() => {
}), lr = 0;
function Ge(e) {
  const [t, n] = s.useState(cr());
  return Ue(() => {
    e || n((r) => r ?? String(lr++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function se(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function dr({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = fr({ defaultProp: t, onChange: n }), a = e !== void 0, u = a ? e : r, i = se(n), f = s.useCallback(
    (l) => {
      if (a) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && i(d);
      } else
        o(l);
    },
    [a, e, o, i]
  );
  return [u, f];
}
function fr({
  defaultProp: e,
  onChange: t
}) {
  const n = s.useState(e), [r] = n, o = s.useRef(r), a = se(t);
  return s.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
var mt = s.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = s.Children.toArray(n), a = o.find(mr);
  if (a) {
    const u = a.props.children, i = o.map((f) => f === a ? s.Children.count(u) > 1 ? s.Children.only(null) : s.isValidElement(u) ? u.props.children : null : f);
    return /* @__PURE__ */ A(ct, { ...r, ref: t, children: s.isValidElement(u) ? s.cloneElement(u, void 0, i) : null });
  }
  return /* @__PURE__ */ A(ct, { ...r, ref: t, children: n });
});
mt.displayName = "Slot";
var ct = s.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (s.isValidElement(n)) {
    const o = hr(n), a = pr(r, n.props);
    return n.type !== s.Fragment && (a.ref = t ? Xt(t, o) : o), s.cloneElement(n, a);
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
ct.displayName = "SlotClone";
var vr = ({ children: e }) => /* @__PURE__ */ A(ut, { children: e });
function mr(e) {
  return s.isValidElement(e) && e.type === vr;
}
function pr(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      a(...i), o(...i);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function hr(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var gr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], J = gr.reduce((e, t) => {
  const n = s.forwardRef((r, o) => {
    const { asChild: a, ...u } = r, i = a ? mt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(i, { ...u, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function wr(e, t) {
  e && or.flushSync(() => e.dispatchEvent(t));
}
function yr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e);
  s.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var br = "DismissableLayer", lt = "dismissableLayer.update", Er = "dismissableLayer.pointerDownOutside", Sr = "dismissableLayer.focusOutside", Nt, Kt = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), qt = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: u,
      onDismiss: i,
      ...f
    } = e, l = s.useContext(Kt), [v, d] = s.useState(null), m = (v == null ? void 0 : v.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, b] = s.useState({}), T = ce(t, (g) => d(g)), c = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), p = c.indexOf(y), P = v ? c.indexOf(v) : -1, C = l.layersWithOutsidePointerEventsDisabled.size > 0, w = P >= p, N = Dr((g) => {
      const D = g.target, O = [...l.branches].some(($) => $.contains(D));
      !w || O || (o == null || o(g), u == null || u(g), g.defaultPrevented || i == null || i());
    }, m), W = Tr((g) => {
      const D = g.target;
      [...l.branches].some(($) => $.contains(D)) || (a == null || a(g), u == null || u(g), g.defaultPrevented || i == null || i());
    }, m);
    return yr((g) => {
      P === l.layers.size - 1 && (r == null || r(g), !g.defaultPrevented && i && (g.preventDefault(), i()));
    }, m), s.useEffect(() => {
      if (v)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Nt = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(v)), l.layers.add(v), Mt(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Nt);
        };
    }, [v, m, n, l]), s.useEffect(() => () => {
      v && (l.layers.delete(v), l.layersWithOutsidePointerEventsDisabled.delete(v), Mt());
    }, [v, l]), s.useEffect(() => {
      const g = () => b({});
      return document.addEventListener(lt, g), () => document.removeEventListener(lt, g);
    }, []), /* @__PURE__ */ A(
      J.div,
      {
        ...f,
        ref: T,
        style: {
          pointerEvents: C ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: oe(e.onFocusCapture, W.onFocusCapture),
        onBlurCapture: oe(e.onBlurCapture, W.onBlurCapture),
        onPointerDownCapture: oe(
          e.onPointerDownCapture,
          N.onPointerDownCapture
        )
      }
    );
  }
);
qt.displayName = br;
var Cr = "DismissableLayerBranch", Rr = s.forwardRef((e, t) => {
  const n = s.useContext(Kt), r = s.useRef(null), o = ce(t, r);
  return s.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ A(J.div, { ...e, ref: o });
});
Rr.displayName = Cr;
function Dr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = s.useRef(!1), o = s.useRef(() => {
  });
  return s.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let f = function() {
          Gt(
            Er,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, u = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(u), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Tr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = s.useRef(!1);
  return s.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Gt(Sr, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Mt() {
  const e = new CustomEvent(lt);
  document.dispatchEvent(e);
}
function Gt(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? wr(o, a) : o.dispatchEvent(a);
}
var Ze = "focusScope.autoFocusOnMount", Qe = "focusScope.autoFocusOnUnmount", It = { bubbles: !1, cancelable: !0 }, Or = "FocusScope", Zt = s.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...u
  } = e, [i, f] = s.useState(null), l = se(o), v = se(a), d = s.useRef(null), m = ce(t, (c) => f(c)), b = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (r) {
      let c = function(C) {
        if (b.paused || !i) return;
        const w = C.target;
        i.contains(w) ? d.current = w : re(d.current, { select: !0 });
      }, y = function(C) {
        if (b.paused || !i) return;
        const w = C.relatedTarget;
        w !== null && (i.contains(w) || re(d.current, { select: !0 }));
      }, p = function(C) {
        if (document.activeElement === document.body)
          for (const N of C)
            N.removedNodes.length > 0 && re(i);
      };
      document.addEventListener("focusin", c), document.addEventListener("focusout", y);
      const P = new MutationObserver(p);
      return i && P.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", c), document.removeEventListener("focusout", y), P.disconnect();
      };
    }
  }, [r, i, b.paused]), s.useEffect(() => {
    if (i) {
      Lt.add(b);
      const c = document.activeElement;
      if (!i.contains(c)) {
        const p = new CustomEvent(Ze, It);
        i.addEventListener(Ze, l), i.dispatchEvent(p), p.defaultPrevented || (Pr(Ir(Qt(i)), { select: !0 }), document.activeElement === c && re(i));
      }
      return () => {
        i.removeEventListener(Ze, l), setTimeout(() => {
          const p = new CustomEvent(Qe, It);
          i.addEventListener(Qe, v), i.dispatchEvent(p), p.defaultPrevented || re(c ?? document.body, { select: !0 }), i.removeEventListener(Qe, v), Lt.remove(b);
        }, 0);
      };
    }
  }, [i, l, v, b]);
  const T = s.useCallback(
    (c) => {
      if (!n && !r || b.paused) return;
      const y = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, p = document.activeElement;
      if (y && p) {
        const P = c.currentTarget, [C, w] = Ar(P);
        C && w ? !c.shiftKey && p === w ? (c.preventDefault(), n && re(C, { select: !0 })) : c.shiftKey && p === C && (c.preventDefault(), n && re(w, { select: !0 })) : p === P && c.preventDefault();
      }
    },
    [n, r, b.paused]
  );
  return /* @__PURE__ */ A(J.div, { tabIndex: -1, ...u, ref: m, onKeyDown: T });
});
Zt.displayName = Or;
function Pr(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (re(r, { select: t }), document.activeElement !== n) return;
}
function Ar(e) {
  const t = Qt(e), n = _t(t, e), r = _t(t.reverse(), e);
  return [n, r];
}
function Qt(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function _t(e, t) {
  for (const n of e)
    if (!xr(n, { upTo: t })) return n;
}
function xr(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Nr(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function re(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Nr(e) && t && e.select();
  }
}
var Lt = Mr();
function Mr() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = kt(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = kt(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function kt(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Ir(e) {
  return e.filter((t) => t.tagName !== "A");
}
var _r = "Portal", Jt = s.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = s.useState(!1);
  Ue(() => a(!0), []);
  const u = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return u ? ar.createPortal(/* @__PURE__ */ A(J.div, { ...r, ref: t }), u) : null;
});
Jt.displayName = _r;
function Lr(e, t) {
  return s.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ve = (e) => {
  const { present: t, children: n } = e, r = kr(t), o = typeof n == "function" ? n({ present: r.isPresent }) : s.Children.only(n), a = ce(r.ref, $r(o));
  return typeof n == "function" || r.isPresent ? s.cloneElement(o, { ref: a }) : null;
};
Ve.displayName = "Presence";
function kr(e) {
  const [t, n] = s.useState(), r = s.useRef({}), o = s.useRef(e), a = s.useRef("none"), u = e ? "mounted" : "unmounted", [i, f] = Lr(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const l = Me(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), Ue(() => {
    const l = r.current, v = o.current;
    if (v !== e) {
      const m = a.current, b = Me(l);
      e ? f("MOUNT") : b === "none" || (l == null ? void 0 : l.display) === "none" ? f("UNMOUNT") : f(v && m !== b ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), Ue(() => {
    if (t) {
      let l;
      const v = t.ownerDocument.defaultView ?? window, d = (b) => {
        const c = Me(r.current).includes(b.animationName);
        if (b.target === t && c && (f("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = v.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, m = (b) => {
        b.target === t && (a.current = Me(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        v.clearTimeout(l), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: s.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Me(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function $r(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Je = 0;
function Fr() {
  s.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? $t()), document.body.insertAdjacentElement("beforeend", e[1] ?? $t()), Je++, () => {
      Je === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Je--;
    };
  }, []);
}
function $t() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Z = function() {
  return Z = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Z.apply(this, arguments);
};
function en(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Wr(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var We = "right-scroll-bar-position", Be = "width-before-scroll-bar", Br = "with-scroll-bars-hidden", Ur = "--removed-body-scroll-bar-size";
function et(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Hr(e, t) {
  var n = Jn(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Vr = typeof window < "u" ? s.useLayoutEffect : s.useEffect, Ft = /* @__PURE__ */ new WeakMap();
function jr(e, t) {
  var n = Hr(null, function(r) {
    return e.forEach(function(o) {
      return et(o, r);
    });
  });
  return Vr(function() {
    var r = Ft.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), u = n.current;
      o.forEach(function(i) {
        a.has(i) || et(i, null);
      }), a.forEach(function(i) {
        o.has(i) || et(i, u);
      });
    }
    Ft.set(n, e);
  }, [e]), n;
}
function zr(e) {
  return e;
}
function Yr(e, t) {
  t === void 0 && (t = zr);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var u = t(a, r);
      return n.push(u), function() {
        n = n.filter(function(i) {
          return i !== u;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var u = n;
        n = [], u.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var u = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), u = n;
      }
      var f = function() {
        var v = u;
        u = [], v.forEach(a);
      }, l = function() {
        return Promise.resolve().then(f);
      };
      l(), n = {
        push: function(v) {
          u.push(v), l();
        },
        filter: function(v) {
          return u = u.filter(v), n;
        }
      };
    }
  };
  return o;
}
function Xr(e) {
  e === void 0 && (e = {});
  var t = Yr(null);
  return t.options = Z({ async: !0, ssr: !1 }, e), t;
}
var tn = function(e) {
  var t = e.sideCar, n = en(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return s.createElement(r, Z({}, n));
};
tn.isSideCarExport = !0;
function Kr(e, t) {
  return e.useMedium(t), tn;
}
var nn = Xr(), tt = function() {
}, je = s.forwardRef(function(e, t) {
  var n = s.useRef(null), r = s.useState({
    onScrollCapture: tt,
    onWheelCapture: tt,
    onTouchMoveCapture: tt
  }), o = r[0], a = r[1], u = e.forwardProps, i = e.children, f = e.className, l = e.removeScrollBar, v = e.enabled, d = e.shards, m = e.sideCar, b = e.noIsolation, T = e.inert, c = e.allowPinchZoom, y = e.as, p = y === void 0 ? "div" : y, P = e.gapMode, C = en(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = m, N = jr([n, t]), W = Z(Z({}, C), o);
  return s.createElement(
    s.Fragment,
    null,
    v && s.createElement(w, { sideCar: nn, removeScrollBar: l, shards: d, noIsolation: b, inert: T, setCallbacks: a, allowPinchZoom: !!c, lockRef: n, gapMode: P }),
    u ? s.cloneElement(s.Children.only(i), Z(Z({}, W), { ref: N })) : s.createElement(p, Z({}, W, { className: f, ref: N }), i)
  );
});
je.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
je.classNames = {
  fullWidth: Be,
  zeroRight: We
};
var qr = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Gr() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = qr();
  return t && e.setAttribute("nonce", t), e;
}
function Zr(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Qr(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Jr = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Gr()) && (Zr(t, n), Qr(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, eo = function() {
  var e = Jr();
  return function(t, n) {
    s.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, rn = function() {
  var e = eo(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, to = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, nt = function(e) {
  return parseInt(e || "", 10) || 0;
}, no = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [nt(n), nt(r), nt(o)];
}, ro = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return to;
  var t = no(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, oo = rn(), we = "data-scroll-locked", ao = function(e, t, n, r) {
  var o = e.left, a = e.top, u = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Br, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(we, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(We, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(Be, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(We, " .").concat(We, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Be, " .").concat(Be, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(we, `] {
    `).concat(Ur, ": ").concat(i, `px;
  }
`);
}, Wt = function() {
  var e = parseInt(document.body.getAttribute(we) || "0", 10);
  return isFinite(e) ? e : 0;
}, io = function() {
  s.useEffect(function() {
    return document.body.setAttribute(we, (Wt() + 1).toString()), function() {
      var e = Wt() - 1;
      e <= 0 ? document.body.removeAttribute(we) : document.body.setAttribute(we, e.toString());
    };
  }, []);
}, so = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  io();
  var a = s.useMemo(function() {
    return ro(o);
  }, [o]);
  return s.createElement(oo, { styles: ao(a, !t, o, n ? "" : "!important") });
}, dt = !1;
if (typeof window < "u")
  try {
    var Ie = Object.defineProperty({}, "passive", {
      get: function() {
        return dt = !0, !0;
      }
    });
    window.addEventListener("test", Ie, Ie), window.removeEventListener("test", Ie, Ie);
  } catch {
    dt = !1;
  }
var me = dt ? { passive: !1 } : !1, uo = function(e) {
  return e.tagName === "TEXTAREA";
}, on = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !uo(e) && n[t] === "visible")
  );
}, co = function(e) {
  return on(e, "overflowY");
}, lo = function(e) {
  return on(e, "overflowX");
}, Bt = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = an(e, r);
    if (o) {
      var a = sn(e, r), u = a[1], i = a[2];
      if (u > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, fo = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, vo = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, an = function(e, t) {
  return e === "v" ? co(t) : lo(t);
}, sn = function(e, t) {
  return e === "v" ? fo(t) : vo(t);
}, mo = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, po = function(e, t, n, r, o) {
  var a = mo(e, window.getComputedStyle(t).direction), u = a * r, i = n.target, f = t.contains(i), l = !1, v = u > 0, d = 0, m = 0;
  do {
    var b = sn(e, i), T = b[0], c = b[1], y = b[2], p = c - y - a * T;
    (T || p) && an(e, i) && (d += p, m += T), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !f && i !== document.body || // self content
    f && (t.contains(i) || t === i)
  );
  return (v && (Math.abs(d) < 1 || !o) || !v && (Math.abs(m) < 1 || !o)) && (l = !0), l;
}, _e = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ut = function(e) {
  return [e.deltaX, e.deltaY];
}, Ht = function(e) {
  return e && "current" in e ? e.current : e;
}, ho = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, go = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, wo = 0, pe = [];
function yo(e) {
  var t = s.useRef([]), n = s.useRef([0, 0]), r = s.useRef(), o = s.useState(wo++)[0], a = s.useState(rn)[0], u = s.useRef(e);
  s.useEffect(function() {
    u.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var c = Wr([e.lockRef.current], (e.shards || []).map(Ht), !0).filter(Boolean);
      return c.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), c.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = s.useCallback(function(c, y) {
    if ("touches" in c && c.touches.length === 2 || c.type === "wheel" && c.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = _e(c), P = n.current, C = "deltaX" in c ? c.deltaX : P[0] - p[0], w = "deltaY" in c ? c.deltaY : P[1] - p[1], N, W = c.target, g = Math.abs(C) > Math.abs(w) ? "h" : "v";
    if ("touches" in c && g === "h" && W.type === "range")
      return !1;
    var D = Bt(g, W);
    if (!D)
      return !0;
    if (D ? N = g : (N = g === "v" ? "h" : "v", D = Bt(g, W)), !D)
      return !1;
    if (!r.current && "changedTouches" in c && (C || w) && (r.current = N), !N)
      return !0;
    var O = r.current || N;
    return po(O, y, c, O === "h" ? C : w, !0);
  }, []), f = s.useCallback(function(c) {
    var y = c;
    if (!(!pe.length || pe[pe.length - 1] !== a)) {
      var p = "deltaY" in y ? Ut(y) : _e(y), P = t.current.filter(function(N) {
        return N.name === y.type && (N.target === y.target || y.target === N.shadowParent) && ho(N.delta, p);
      })[0];
      if (P && P.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!P) {
        var C = (u.current.shards || []).map(Ht).filter(Boolean).filter(function(N) {
          return N.contains(y.target);
        }), w = C.length > 0 ? i(y, C[0]) : !u.current.noIsolation;
        w && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = s.useCallback(function(c, y, p, P) {
    var C = { name: c, delta: y, target: p, should: P, shadowParent: bo(p) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== C;
      });
    }, 1);
  }, []), v = s.useCallback(function(c) {
    n.current = _e(c), r.current = void 0;
  }, []), d = s.useCallback(function(c) {
    l(c.type, Ut(c), c.target, i(c, e.lockRef.current));
  }, []), m = s.useCallback(function(c) {
    l(c.type, _e(c), c.target, i(c, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return pe.push(a), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", f, me), document.addEventListener("touchmove", f, me), document.addEventListener("touchstart", v, me), function() {
      pe = pe.filter(function(c) {
        return c !== a;
      }), document.removeEventListener("wheel", f, me), document.removeEventListener("touchmove", f, me), document.removeEventListener("touchstart", v, me);
    };
  }, []);
  var b = e.removeScrollBar, T = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    T ? s.createElement(a, { styles: go(o) }) : null,
    b ? s.createElement(so, { gapMode: e.gapMode }) : null
  );
}
function bo(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Eo = Kr(nn, yo);
var un = s.forwardRef(function(e, t) {
  return s.createElement(je, Z({}, e, { ref: t, sideCar: Eo }));
});
un.classNames = je.classNames;
var So = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, he = /* @__PURE__ */ new WeakMap(), Le = /* @__PURE__ */ new WeakMap(), ke = {}, rt = 0, cn = function(e) {
  return e && (e.host || cn(e.parentNode));
}, Co = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = cn(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Ro = function(e, t, n, r) {
  var o = Co(t, Array.isArray(e) ? e : [e]);
  ke[n] || (ke[n] = /* @__PURE__ */ new WeakMap());
  var a = ke[n], u = [], i = /* @__PURE__ */ new Set(), f = new Set(o), l = function(d) {
    !d || i.has(d) || (i.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var v = function(d) {
    !d || f.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (i.has(m))
        v(m);
      else
        try {
          var b = m.getAttribute(r), T = b !== null && b !== "false", c = (he.get(m) || 0) + 1, y = (a.get(m) || 0) + 1;
          he.set(m, c), a.set(m, y), u.push(m), c === 1 && T && Le.set(m, !0), y === 1 && m.setAttribute(n, "true"), T || m.setAttribute(r, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", m, p);
        }
    });
  };
  return v(t), i.clear(), rt++, function() {
    u.forEach(function(d) {
      var m = he.get(d) - 1, b = a.get(d) - 1;
      he.set(d, m), a.set(d, b), m || (Le.has(d) || d.removeAttribute(r), Le.delete(d)), b || d.removeAttribute(n);
    }), rt--, rt || (he = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap(), Le = /* @__PURE__ */ new WeakMap(), ke = {});
  };
}, Do = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = So(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Ro(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, pt = "Dialog", [ln, Ea] = sr(pt), [To, q] = ln(pt), dn = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: u = !0
  } = e, i = s.useRef(null), f = s.useRef(null), [l = !1, v] = dr({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ A(
    To,
    {
      scope: t,
      triggerRef: i,
      contentRef: f,
      contentId: Ge(),
      titleId: Ge(),
      descriptionId: Ge(),
      open: l,
      onOpenChange: v,
      onOpenToggle: s.useCallback(() => v((d) => !d), [v]),
      modal: u,
      children: n
    }
  );
};
dn.displayName = pt;
var fn = "DialogTrigger", vn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = q(fn, n), a = ce(t, o.triggerRef);
    return /* @__PURE__ */ A(
      J.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": wt(o.open),
        ...r,
        ref: a,
        onClick: oe(e.onClick, o.onOpenToggle)
      }
    );
  }
);
vn.displayName = fn;
var ht = "DialogPortal", [Oo, mn] = ln(ht, {
  forceMount: void 0
}), pn = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = q(ht, t);
  return /* @__PURE__ */ A(Oo, { scope: t, forceMount: n, children: s.Children.map(r, (u) => /* @__PURE__ */ A(Ve, { present: n || a.open, children: /* @__PURE__ */ A(Jt, { asChild: !0, container: o, children: u }) })) });
};
pn.displayName = ht;
var He = "DialogOverlay", hn = s.forwardRef(
  (e, t) => {
    const n = mn(He, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = q(He, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ A(Ve, { present: r || a.open, children: /* @__PURE__ */ A(Po, { ...o, ref: t }) }) : null;
  }
);
hn.displayName = He;
var Po = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = q(He, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ A(un, { as: mt, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ A(
        J.div,
        {
          "data-state": wt(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), ue = "DialogContent", gn = s.forwardRef(
  (e, t) => {
    const n = mn(ue, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = q(ue, e.__scopeDialog);
    return /* @__PURE__ */ A(Ve, { present: r || a.open, children: a.modal ? /* @__PURE__ */ A(Ao, { ...o, ref: t }) : /* @__PURE__ */ A(xo, { ...o, ref: t }) });
  }
);
gn.displayName = ue;
var Ao = s.forwardRef(
  (e, t) => {
    const n = q(ue, e.__scopeDialog), r = s.useRef(null), o = ce(t, n.contentRef, r);
    return s.useEffect(() => {
      const a = r.current;
      if (a) return Do(a);
    }, []), /* @__PURE__ */ A(
      wn,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: oe(e.onCloseAutoFocus, (a) => {
          var u;
          a.preventDefault(), (u = n.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: oe(e.onPointerDownOutside, (a) => {
          const u = a.detail.originalEvent, i = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: oe(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), xo = s.forwardRef(
  (e, t) => {
    const n = q(ue, e.__scopeDialog), r = s.useRef(!1), o = s.useRef(!1);
    return /* @__PURE__ */ A(
      wn,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var u, i;
          (u = e.onCloseAutoFocus) == null || u.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var f, l;
          (f = e.onInteractOutside) == null || f.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const u = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(u)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), wn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...u } = e, i = q(ue, n), f = s.useRef(null), l = ce(t, f);
    return Fr(), /* @__PURE__ */ Oe(ut, { children: [
      /* @__PURE__ */ A(
        Zt,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ A(
            qt,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": wt(i.open),
              ...u,
              ref: l,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Oe(ut, { children: [
        /* @__PURE__ */ A(No, { titleId: i.titleId }),
        /* @__PURE__ */ A(Io, { contentRef: f, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), gt = "DialogTitle", yn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = q(gt, n);
    return /* @__PURE__ */ A(J.h2, { id: o.titleId, ...r, ref: t });
  }
);
yn.displayName = gt;
var bn = "DialogDescription", En = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = q(bn, n);
    return /* @__PURE__ */ A(J.p, { id: o.descriptionId, ...r, ref: t });
  }
);
En.displayName = bn;
var Sn = "DialogClose", Cn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = q(Sn, n);
    return /* @__PURE__ */ A(
      J.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: oe(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Cn.displayName = Sn;
function wt(e) {
  return e ? "open" : "closed";
}
var Rn = "DialogTitleWarning", [Sa, Dn] = ir(Rn, {
  contentName: ue,
  titleName: gt,
  docsSlug: "dialog"
}), No = ({ titleId: e }) => {
  const t = Dn(Rn), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Mo = "DialogDescriptionWarning", Io = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Dn(Mo).contentName}}.`;
  return s.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, _o = dn, Lo = vn, ko = pn, $o = hn, Fo = gn, Wo = yn, Bo = En, Uo = Cn;
function Ho(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const Tn = h.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ye = () => {
  const e = h.useContext(Tn);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Ho(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Vo() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function jo() {
  return yt(/^Mac/);
}
function zo() {
  return yt(/^iPhone/);
}
function Vt() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Yo() {
  return yt(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  jo() && navigator.maxTouchPoints > 1;
}
function On() {
  return zo() || Yo();
}
function yt(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Xo = 24, Ko = typeof window < "u" ? tr : nr;
function jt(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const ot = typeof document < "u" && window.visualViewport;
function zt(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Pn(e) {
  for (zt(e) && (e = e.parentElement); e && !zt(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const qo = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $e = 0, at;
function Go(e = {}) {
  let { isDisabled: t } = e;
  Ko(() => {
    if (!t)
      return $e++, $e === 1 && On() && (at = Zo()), () => {
        $e--, $e === 0 && (at == null || at());
      };
  }, [
    t
  ]);
}
function Zo() {
  let e, t = 0, n = (d) => {
    e = Pn(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let m = d.changedTouches[0].pageY, b = e.scrollTop, T = e.scrollHeight - e.clientHeight;
    T !== 0 && ((b <= 0 && m > t || b >= T && m < t) && d.preventDefault(), t = m);
  }, o = (d) => {
    let m = d.target;
    ft(m) && m !== document.activeElement && (d.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, a = (d) => {
    let m = d.target;
    ft(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", ot && (ot.height < window.innerHeight ? requestAnimationFrame(() => {
        Yt(m);
      }) : ot.addEventListener("resize", () => Yt(m), {
        once: !0
      }));
    }));
  }, u = () => {
    window.scrollTo(0, 0);
  }, i = window.pageXOffset, f = window.pageYOffset, l = jt(Qo(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let v = jt(De(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), De(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), De(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), De(document, "focus", a, !0), De(window, "scroll", u));
  return () => {
    l(), v(), window.scrollTo(i, f);
  };
}
function Qo(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function De(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Yt(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = Pn(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom;
      const u = n.getBoundingClientRect().bottom + Xo;
      a > u && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function ft(e) {
  return e instanceof HTMLInputElement && !qo.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Jo(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ea(...e) {
  return (t) => e.forEach((n) => Jo(n, t));
}
function An(...e) {
  return s.useCallback(ea(...e), e);
}
const xn = /* @__PURE__ */ new WeakMap();
function F(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, a]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, a);
      return;
    }
    r[o] = e.style[o], e.style[o] = a;
  }), !n && xn.set(e, r);
}
function ta(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = xn.get(e);
  n && (e.style[t] = n[t]);
}
const k = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Fe(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[k(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[k(t) ? 5 : 4]) : null);
}
function na(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function it(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function ra(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const _ = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Nn = 0.4, oa = 0.25, aa = 100, Mn = 8, ie = 16, vt = 26, st = "vaul-dragging";
function In(e) {
  const t = h.useRef(e);
  return h.useEffect(() => {
    t.current = e;
  }), h.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function ia({ defaultProp: e, onChange: t }) {
  const n = h.useState(e), [r] = n, o = h.useRef(r), a = In(t);
  return h.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function _n({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = ia({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, u = a ? e : r, i = In(n), f = h.useCallback((l) => {
    if (a) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && i(d);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    i
  ]);
  return [
    u,
    f
  ];
}
function sa({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: a, onSnapPointChange: u, direction: i = "bottom", container: f, snapToSequentialPoint: l }) {
  const [v, d] = _n({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [m, b] = h.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  h.useEffect(() => {
    function g() {
      b({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", g), () => window.removeEventListener("resize", g);
  }, []);
  const T = h.useMemo(() => v === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    v
  ]), c = h.useMemo(() => {
    var g;
    return (g = n == null ? void 0 : n.findIndex((D) => D === v)) != null ? g : null;
  }, [
    n,
    v
  ]), y = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === v || !n, p = h.useMemo(() => {
    const g = f ? {
      width: f.getBoundingClientRect().width,
      height: f.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var D;
    return (D = n == null ? void 0 : n.map((O) => {
      const $ = typeof O == "string";
      let B = 0;
      if ($ && (B = parseInt(O, 10)), k(i)) {
        const S = $ ? B : m ? O * g.height : 0;
        return m ? i === "bottom" ? g.height - S : -g.height + S : S;
      }
      const Y = $ ? B : m ? O * g.width : 0;
      return m ? i === "right" ? g.width - Y : -g.width + Y : Y;
    })) != null ? D : [];
  }, [
    n,
    m,
    f
  ]), P = h.useMemo(() => c !== null ? p == null ? void 0 : p[c] : null, [
    p,
    c
  ]), C = h.useCallback((g) => {
    var D;
    const O = (D = p == null ? void 0 : p.findIndex(($) => $ === g)) != null ? D : null;
    u(O), F(r.current, {
      transition: `transform ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      transform: k(i) ? `translate3d(0, ${g}px, 0)` : `translate3d(${g}px, 0, 0)`
    }), p && O !== p.length - 1 && a !== void 0 && O !== a && O < a ? F(o.current, {
      transition: `opacity ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      opacity: "0"
    }) : F(o.current, {
      transition: `opacity ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(O, 0)]);
  }, [
    r.current,
    n,
    p,
    a,
    o,
    d
  ]);
  h.useEffect(() => {
    if (v || e) {
      var g;
      const D = (g = n == null ? void 0 : n.findIndex((O) => O === e || O === v)) != null ? g : -1;
      p && D !== -1 && typeof p[D] == "number" && C(p[D]);
    }
  }, [
    v,
    e,
    n,
    p,
    C
  ]);
  function w({ draggedDistance: g, closeDrawer: D, velocity: O, dismissible: $ }) {
    if (a === void 0) return;
    const B = i === "bottom" || i === "right" ? (P ?? 0) - g : (P ?? 0) + g, Y = c === a - 1, S = c === 0, z = g > 0;
    if (Y && F(o.current, {
      transition: `opacity ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`
    }), !l && O > 2 && !z) {
      $ ? D() : C(p[0]);
      return;
    }
    if (!l && O > 2 && z && p && n) {
      C(p[n.length - 1]);
      return;
    }
    const H = p == null ? void 0 : p.reduce((U, Q) => typeof U != "number" || typeof Q != "number" ? U : Math.abs(Q - B) < Math.abs(U - B) ? Q : U), X = k(i) ? window.innerHeight : window.innerWidth;
    if (O > Nn && Math.abs(g) < X * 0.4) {
      const U = z ? 1 : -1;
      if (U > 0 && T && n) {
        C(p[n.length - 1]);
        return;
      }
      if (S && U < 0 && $ && D(), c === null) return;
      C(p[c + U]);
      return;
    }
    C(H);
  }
  function N({ draggedDistance: g }) {
    if (P === null) return;
    const D = i === "bottom" || i === "right" ? P - g : P + g;
    (i === "bottom" || i === "right") && D < p[p.length - 1] || (i === "top" || i === "left") && D > p[p.length - 1] || F(r.current, {
      transform: k(i) ? `translate3d(0, ${D}px, 0)` : `translate3d(${D}px, 0, 0)`
    });
  }
  function W(g, D) {
    if (!n || typeof c != "number" || !p || a === void 0) return null;
    const O = c === a - 1;
    if (c >= a && D)
      return 0;
    if (O && !D) return 1;
    if (!y && !O) return null;
    const B = O ? c + 1 : c - 1, Y = O ? p[B] - p[B - 1] : p[B + 1] - p[B], S = g / Math.abs(Y);
    return O ? 1 - S : S;
  }
  return {
    isLastSnapPoint: T,
    activeSnapPoint: v,
    shouldFade: y,
    getPercentageDragged: W,
    setActiveSnapPoint: d,
    activeSnapPointIndex: c,
    onRelease: w,
    onDrag: N,
    snapPointsOffset: p
  };
}
const ua = () => () => {
};
function ca() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = ye(), a = h.useRef(null), u = er(() => document.body.style.backgroundColor, []);
  function i() {
    return (window.innerWidth - vt) / window.innerWidth;
  }
  h.useEffect(() => {
    if (t && n) {
      a.current && clearTimeout(a.current);
      const f = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!f) return;
      ra(r && !o ? it(document.body, {
        background: "black"
      }) : ua, it(f, {
        transformOrigin: k(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${_.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${_.EASE.join(",")})`
      }));
      const l = it(f, {
        borderRadius: `${Mn}px`,
        overflow: "hidden",
        ...k(e) ? {
          transform: `scale(${i()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${i()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        l(), a.current = window.setTimeout(() => {
          u ? document.body.style.background = u : document.body.style.removeProperty("background");
        }, _.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    u
  ]);
}
let Te = null;
function la({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: a }) {
  const [u, i] = h.useState(() => typeof window < "u" ? window.location.href : ""), f = h.useRef(0), l = h.useCallback(() => {
    if (Vt() && Te === null && e && !a) {
      Te = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-f.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const b = m - window.innerHeight;
        b && f.current >= m && (document.body.style.top = `${-(f.current + b)}px`);
      }), 300);
    }
  }, [
    e
  ]), v = h.useCallback(() => {
    if (Vt() && Te !== null && !a) {
      const d = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Te), window.requestAnimationFrame(() => {
        if (o && u !== window.location.href) {
          i(window.location.href);
          return;
        }
        window.scrollTo(m, d);
      }), Te = null;
    }
  }, [
    u
  ]);
  return h.useEffect(() => {
    function d() {
      f.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), h.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || v();
      };
  }, [
    t,
    v
  ]), h.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && l(), t || window.setTimeout(() => {
      v();
    }, 500)) : v());
  }, [
    e,
    r,
    u,
    t,
    n,
    l,
    v
  ]), {
    restorePositionSetting: v
  };
}
function Ln({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: a, shouldScaleBackground: u = !1, setBackgroundColorOnScale: i = !0, closeThreshold: f = oa, scrollLockTimeout: l = aa, dismissible: v = !0, handleOnly: d = !1, fadeFromIndex: m = a && a.length - 1, activeSnapPoint: b, setActiveSnapPoint: T, fixed: c, modal: y = !0, onClose: p, nested: P, noBodyStyles: C = !1, direction: w = "bottom", defaultOpen: N = !1, disablePreventScroll: W = !0, snapToSequentialPoint: g = !1, preventScrollRestoration: D = !1, repositionInputs: O = !0, onAnimationEnd: $, container: B, autoFocus: Y = !1 }) {
  var S, z;
  const [H = !1, X] = _n({
    defaultProp: N,
    prop: e,
    onChange: (E) => {
      t == null || t(E), !E && !P && zn(), setTimeout(() => {
        $ == null || $(E);
      }, _.DURATION * 1e3), E && !y && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), E || (document.body.style.pointerEvents = "auto");
    }
  }), [U, Q] = h.useState(!1), [ee, be] = h.useState(!1), [Wn, bt] = h.useState(!1), le = h.useRef(null), Pe = h.useRef(null), ze = h.useRef(null), Ye = h.useRef(null), Ee = h.useRef(null), Se = h.useRef(!1), Xe = h.useRef(null), Ke = h.useRef(0), de = h.useRef(!1), Et = h.useRef(!N), St = h.useRef(0), R = h.useRef(null), Ct = h.useRef(((S = R.current) == null ? void 0 : S.getBoundingClientRect().height) || 0), Rt = h.useRef(((z = R.current) == null ? void 0 : z.getBoundingClientRect().width) || 0), qe = h.useRef(0), Bn = h.useCallback((E) => {
    a && E === Ce.length - 1 && (Pe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Un, activeSnapPointIndex: fe, setActiveSnapPoint: Dt, onRelease: Hn, snapPointsOffset: Ce, onDrag: Vn, shouldFade: Tt, getPercentageDragged: jn } = sa({
    snapPoints: a,
    activeSnapPointProp: b,
    setActiveSnapPointProp: T,
    drawerRef: R,
    fadeFromIndex: m,
    overlayRef: le,
    onSnapPointChange: Bn,
    direction: w,
    container: B,
    snapToSequentialPoint: g
  });
  Go({
    isDisabled: !H || ee || !y || Wn || !U || !O || !W
  });
  const { restorePositionSetting: zn } = la({
    isOpen: H,
    modal: y,
    nested: P ?? !1,
    hasBeenOpened: U,
    preventScrollRestoration: D,
    noBodyStyles: C
  });
  function Ae() {
    return (window.innerWidth - vt) / window.innerWidth;
  }
  function Yn(E) {
    var M, I;
    !v && !a || R.current && !R.current.contains(E.target) || (Ct.current = ((M = R.current) == null ? void 0 : M.getBoundingClientRect().height) || 0, Rt.current = ((I = R.current) == null ? void 0 : I.getBoundingClientRect().width) || 0, be(!0), ze.current = /* @__PURE__ */ new Date(), On() && window.addEventListener("touchend", () => Se.current = !1, {
      once: !0
    }), E.target.setPointerCapture(E.pointerId), Ke.current = k(w) ? E.pageY : E.pageX);
  }
  function Ot(E, M) {
    var I;
    let x = E;
    const L = (I = window.getSelection()) == null ? void 0 : I.toString(), j = R.current ? Fe(R.current, w) : null, V = /* @__PURE__ */ new Date();
    if (x.tagName === "SELECT" || x.hasAttribute("data-vaul-no-drag") || x.closest("[data-vaul-no-drag]"))
      return !1;
    if (w === "right" || w === "left")
      return !0;
    if (Pe.current && V.getTime() - Pe.current.getTime() < 500)
      return !1;
    if (j !== null && (w === "bottom" ? j > 0 : j < 0))
      return !0;
    if (L && L.length > 0)
      return !1;
    if (Ee.current && V.getTime() - Ee.current.getTime() < l && j === 0 || M)
      return Ee.current = V, !1;
    for (; x; ) {
      if (x.scrollHeight > x.clientHeight) {
        if (x.scrollTop !== 0)
          return Ee.current = /* @__PURE__ */ new Date(), !1;
        if (x.getAttribute("role") === "dialog")
          return !0;
      }
      x = x.parentNode;
    }
    return !0;
  }
  function Xn(E) {
    if (R.current && ee) {
      const M = w === "bottom" || w === "right" ? 1 : -1, I = (Ke.current - (k(w) ? E.pageY : E.pageX)) * M, x = I > 0, L = a && !v && !x;
      if (L && fe === 0) return;
      const j = Math.abs(I), V = document.querySelector("[data-vaul-drawer-wrapper]"), te = w === "bottom" || w === "top" ? Ct.current : Rt.current;
      let K = j / te;
      const ae = jn(j, x);
      if (ae !== null && (K = ae), L && K >= 1 || !Se.current && !Ot(E.target, x)) return;
      if (R.current.classList.add(st), Se.current = !0, F(R.current, {
        transition: "none"
      }), F(le.current, {
        transition: "none"
      }), a && Vn({
        draggedDistance: I
      }), x && !a) {
        const G = na(I), xe = Math.min(G * -1, 0) * M;
        F(R.current, {
          transform: k(w) ? `translate3d(0, ${xe}px, 0)` : `translate3d(${xe}px, 0, 0)`
        });
        return;
      }
      const ne = 1 - K;
      if ((Tt || m && fe === m - 1) && (r == null || r(E, K), F(le.current, {
        opacity: `${ne}`,
        transition: "none"
      }, !0)), V && le.current && u) {
        const G = Math.min(Ae() + K * (1 - Ae()), 1), xe = 8 - K * 8, At = Math.max(0, 14 - K * 14);
        F(V, {
          borderRadius: `${xe}px`,
          transform: k(w) ? `scale(${G}) translate3d(0, ${At}px, 0)` : `scale(${G}) translate3d(${At}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const G = j * M;
        F(R.current, {
          transform: k(w) ? `translate3d(0, ${G}px, 0)` : `translate3d(${G}px, 0, 0)`
        });
      }
    }
  }
  h.useEffect(() => {
    window.requestAnimationFrame(() => {
      Et.current = !0;
    });
  }, []), h.useEffect(() => {
    var E;
    function M() {
      if (!R.current || !O) return;
      const I = document.activeElement;
      if (ft(I) || de.current) {
        var x;
        const L = ((x = window.visualViewport) == null ? void 0 : x.height) || 0, j = window.innerHeight;
        let V = j - L;
        const te = R.current.getBoundingClientRect().height || 0, K = te > j * 0.8;
        qe.current || (qe.current = te);
        const ae = R.current.getBoundingClientRect().top;
        if (Math.abs(St.current - V) > 60 && (de.current = !de.current), a && a.length > 0 && Ce && fe) {
          const ne = Ce[fe] || 0;
          V += ne;
        }
        if (St.current = V, te > L || de.current) {
          const ne = R.current.getBoundingClientRect().height;
          let G = ne;
          ne > L && (G = L - (K ? ae : vt)), c ? R.current.style.height = `${ne - Math.max(V, 0)}px` : R.current.style.height = `${Math.max(G, L - ae)}px`;
        } else Vo() || (R.current.style.height = `${qe.current}px`);
        a && a.length > 0 && !de.current ? R.current.style.bottom = "0px" : R.current.style.bottom = `${Math.max(V, 0)}px`;
      }
    }
    return (E = window.visualViewport) == null || E.addEventListener("resize", M), () => {
      var I;
      return (I = window.visualViewport) == null ? void 0 : I.removeEventListener("resize", M);
    };
  }, [
    fe,
    a,
    Ce
  ]);
  function Re(E) {
    Kn(), p == null || p(), E || X(!1), setTimeout(() => {
      a && Dt(a[0]);
    }, _.DURATION * 1e3);
  }
  function Pt() {
    if (!R.current) return;
    const E = document.querySelector("[data-vaul-drawer-wrapper]"), M = Fe(R.current, w);
    F(R.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`
    }), F(le.current, {
      transition: `opacity ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      opacity: "1"
    }), u && M && M > 0 && H && F(E, {
      borderRadius: `${Mn}px`,
      overflow: "hidden",
      ...k(w) ? {
        transform: `scale(${Ae()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Ae()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${_.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${_.EASE.join(",")})`
    }, !0);
  }
  function Kn() {
    !ee || !R.current || (R.current.classList.remove(st), Se.current = !1, be(!1), Ye.current = /* @__PURE__ */ new Date());
  }
  function qn(E) {
    if (!ee || !R.current) return;
    R.current.classList.remove(st), Se.current = !1, be(!1), Ye.current = /* @__PURE__ */ new Date();
    const M = Fe(R.current, w);
    if (!E || !Ot(E.target, !1) || !M || Number.isNaN(M) || ze.current === null) return;
    const I = Ye.current.getTime() - ze.current.getTime(), x = Ke.current - (k(w) ? E.pageY : E.pageX), L = Math.abs(x) / I;
    if (L > 0.05 && (bt(!0), setTimeout(() => {
      bt(!1);
    }, 200)), a) {
      Hn({
        draggedDistance: x * (w === "bottom" || w === "right" ? 1 : -1),
        closeDrawer: Re,
        velocity: L,
        dismissible: v
      }), o == null || o(E, !0);
      return;
    }
    if (w === "bottom" || w === "right" ? x > 0 : x < 0) {
      Pt(), o == null || o(E, !0);
      return;
    }
    if (L > Nn) {
      Re(), o == null || o(E, !1);
      return;
    }
    var j;
    const V = Math.min((j = R.current.getBoundingClientRect().height) != null ? j : 0, window.innerHeight);
    var te;
    const K = Math.min((te = R.current.getBoundingClientRect().width) != null ? te : 0, window.innerWidth), ae = w === "left" || w === "right";
    if (Math.abs(M) >= (ae ? K : V) * f) {
      Re(), o == null || o(E, !1);
      return;
    }
    o == null || o(E, !0), Pt();
  }
  h.useEffect(() => (H && (F(document.documentElement, {
    scrollBehavior: "auto"
  }), Pe.current = /* @__PURE__ */ new Date()), () => {
    ta(document.documentElement, "scrollBehavior");
  }), [
    H
  ]);
  function Gn(E) {
    const M = E ? (window.innerWidth - ie) / window.innerWidth : 1, I = E ? -ie : 0;
    Xe.current && window.clearTimeout(Xe.current), F(R.current, {
      transition: `transform ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      transform: k(w) ? `scale(${M}) translate3d(0, ${I}px, 0)` : `scale(${M}) translate3d(${I}px, 0, 0)`
    }), !E && R.current && (Xe.current = setTimeout(() => {
      const x = Fe(R.current, w);
      F(R.current, {
        transition: "none",
        transform: k(w) ? `translate3d(0, ${x}px, 0)` : `translate3d(${x}px, 0, 0)`
      });
    }, 500));
  }
  function Zn(E, M) {
    if (M < 0) return;
    const I = (window.innerWidth - ie) / window.innerWidth, x = I + M * (1 - I), L = -ie + M * ie;
    F(R.current, {
      transform: k(w) ? `scale(${x}) translate3d(0, ${L}px, 0)` : `scale(${x}) translate3d(${L}px, 0, 0)`,
      transition: "none"
    });
  }
  function Qn(E, M) {
    const I = k(w) ? window.innerHeight : window.innerWidth, x = M ? (I - ie) / I : 1, L = M ? -ie : 0;
    M && F(R.current, {
      transition: `transform ${_.DURATION}s cubic-bezier(${_.EASE.join(",")})`,
      transform: k(w) ? `scale(${x}) translate3d(0, ${L}px, 0)` : `scale(${x}) translate3d(${L}px, 0, 0)`
    });
  }
  return h.useEffect(() => {
    y || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    y
  ]), /* @__PURE__ */ h.createElement(_o, {
    defaultOpen: N,
    onOpenChange: (E) => {
      !v && !E || (E ? Q(!0) : Re(!0), X(E));
    },
    open: H
  }, /* @__PURE__ */ h.createElement(Tn.Provider, {
    value: {
      activeSnapPoint: Un,
      snapPoints: a,
      setActiveSnapPoint: Dt,
      drawerRef: R,
      overlayRef: le,
      onOpenChange: t,
      onPress: Yn,
      onRelease: qn,
      onDrag: Xn,
      dismissible: v,
      shouldAnimate: Et,
      handleOnly: d,
      isOpen: H,
      isDragging: ee,
      shouldFade: Tt,
      closeDrawer: Re,
      onNestedDrag: Zn,
      onNestedOpenChange: Gn,
      onNestedRelease: Qn,
      keyboardIsOpen: de,
      modal: y,
      snapPointsOffset: Ce,
      activeSnapPointIndex: fe,
      direction: w,
      shouldScaleBackground: u,
      setBackgroundColorOnScale: i,
      noBodyStyles: C,
      container: B,
      autoFocus: Y
    }
  }, n));
}
const kn = /* @__PURE__ */ h.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: a, isOpen: u, modal: i, shouldAnimate: f } = ye(), l = An(t, n), v = r && r.length > 0;
  if (!i)
    return null;
  const d = h.useCallback((m) => o(m), [
    o
  ]);
  return /* @__PURE__ */ h.createElement($o, {
    onMouseUp: d,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": u && v ? "true" : "false",
    "data-vaul-snap-points-overlay": u && a ? "true" : "false",
    "data-vaul-animate": f != null && f.current ? "true" : "false",
    ...e
  });
});
kn.displayName = "Drawer.Overlay";
const $n = /* @__PURE__ */ h.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: a, onPress: u, onRelease: i, onDrag: f, keyboardIsOpen: l, snapPointsOffset: v, activeSnapPointIndex: d, modal: m, isOpen: b, direction: T, snapPoints: c, container: y, handleOnly: p, shouldAnimate: P, autoFocus: C } = ye(), [w, N] = h.useState(!1), W = An(o, a), g = h.useRef(null), D = h.useRef(null), O = h.useRef(!1), $ = c && c.length > 0;
  ca();
  const B = (S, z, H = 0) => {
    if (O.current) return !0;
    const X = Math.abs(S.y), U = Math.abs(S.x), Q = U > X, ee = [
      "bottom",
      "right"
    ].includes(z) ? 1 : -1;
    if (z === "left" || z === "right") {
      if (!(S.x * ee < 0) && U >= 0 && U <= H)
        return Q;
    } else if (!(S.y * ee < 0) && X >= 0 && X <= H)
      return !Q;
    return O.current = !0, !0;
  };
  h.useEffect(() => {
    $ && window.requestAnimationFrame(() => {
      N(!0);
    });
  }, []);
  function Y(S) {
    g.current = null, O.current = !1, i(S);
  }
  return /* @__PURE__ */ h.createElement(Fo, {
    "data-vaul-drawer-direction": T,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": w ? "true" : "false",
    "data-vaul-snap-points": b && $ ? "true" : "false",
    "data-vaul-custom-container": y ? "true" : "false",
    "data-vaul-animate": P != null && P.current ? "true" : "false",
    ...r,
    ref: W,
    style: v && v.length > 0 ? {
      "--snap-point-height": `${v[d ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (S) => {
      p || (r.onPointerDown == null || r.onPointerDown.call(r, S), g.current = {
        x: S.pageX,
        y: S.pageY
      }, u(S));
    },
    onOpenAutoFocus: (S) => {
      n == null || n(S), C || S.preventDefault();
    },
    onPointerDownOutside: (S) => {
      if (e == null || e(S), !m || S.defaultPrevented) {
        S.preventDefault();
        return;
      }
      l.current && (l.current = !1);
    },
    onFocusOutside: (S) => {
      if (!m) {
        S.preventDefault();
        return;
      }
    },
    onPointerMove: (S) => {
      if (D.current = S, p || (r.onPointerMove == null || r.onPointerMove.call(r, S), !g.current)) return;
      const z = S.pageY - g.current.y, H = S.pageX - g.current.x, X = S.pointerType === "touch" ? 10 : 2;
      B({
        x: H,
        y: z
      }, T, X) ? f(S) : (Math.abs(H) > X || Math.abs(z) > X) && (g.current = null);
    },
    onPointerUp: (S) => {
      r.onPointerUp == null || r.onPointerUp.call(r, S), g.current = null, O.current = !1, i(S);
    },
    onPointerOut: (S) => {
      r.onPointerOut == null || r.onPointerOut.call(r, S), Y(D.current);
    },
    onContextMenu: (S) => {
      r.onContextMenu == null || r.onContextMenu.call(r, S), D.current && Y(D.current);
    }
  });
});
$n.displayName = "Drawer.Content";
const da = 250, fa = 120, Fn = /* @__PURE__ */ h.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: a, snapPoints: u, activeSnapPoint: i, setActiveSnapPoint: f, dismissible: l, handleOnly: v, isOpen: d, onPress: m, onDrag: b } = ye(), T = h.useRef(null), c = h.useRef(!1);
  function y() {
    if (c.current) {
      C();
      return;
    }
    window.setTimeout(() => {
      p();
    }, fa);
  }
  function p() {
    if (a || e || c.current) {
      C();
      return;
    }
    if (C(), !u || u.length === 0) {
      l || o();
      return;
    }
    if (i === u[u.length - 1] && l) {
      o();
      return;
    }
    const N = u.findIndex((g) => g === i);
    if (N === -1) return;
    const W = u[N + 1];
    f(W);
  }
  function P() {
    T.current = window.setTimeout(() => {
      c.current = !0;
    }, da);
  }
  function C() {
    T.current && window.clearTimeout(T.current), c.current = !1;
  }
  return /* @__PURE__ */ h.createElement("div", {
    onClick: y,
    onPointerCancel: C,
    onPointerDown: (w) => {
      v && m(w), P();
    },
    onPointerMove: (w) => {
      v && b(w);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ h.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Fn.displayName = "Drawer.Handle";
function va({ onDrag: e, onOpenChange: t, open: n, ...r }) {
  const { onNestedDrag: o, onNestedOpenChange: a, onNestedRelease: u } = ye();
  if (!o)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ h.createElement(Ln, {
    nested: !0,
    open: n,
    onClose: () => {
      a(!1);
    },
    onDrag: (i, f) => {
      o(i, f), e == null || e(i, f);
    },
    onOpenChange: (i) => {
      i && a(i), t == null || t(i);
    },
    onRelease: u,
    ...r
  });
}
function ma(e) {
  const t = ye(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ h.createElement(ko, {
    container: n,
    ...r
  });
}
const ge = {
  Root: Ln,
  NestedRoot: va,
  Content: $n,
  Overlay: kn,
  Trigger: Lo,
  Portal: ma,
  Handle: Fn,
  Close: Uo,
  Title: Wo,
  Description: Bo
}, pa = rr(
  ({
    isOpen: e,
    dismissible: t,
    variant: n = "bottom",
    classNames: r,
    style: o,
    children: a
  }) => /* @__PURE__ */ Oe(ge.Portal, { children: [
    /* @__PURE__ */ A(
      ge.Overlay,
      {
        className: Ne(ve.overlay, r == null ? void 0 : r.overlay)
      }
    ),
    /* @__PURE__ */ A(
      ge.Content,
      {
        className: Ne(
          ve.wrapper.base,
          ve.wrapper.variants[n],
          r == null ? void 0 : r.wrapper
        ),
        style: o,
        children: /* @__PURE__ */ Oe(
          "div",
          {
            className: Ne(
              ve.inner.base,
              ve.inner.variants[n],
              r == null ? void 0 : r.inner
            ),
            "data-open": e,
            children: [
              t && /* @__PURE__ */ A(ge.Handle, { className: Ne(ve.handle[n]) }),
              /* @__PURE__ */ Oe("div", { className: "hide", children: [
                /* @__PURE__ */ A(ge.Title, {}),
                /* @__PURE__ */ A(ge.Description, {})
              ] }),
              a
            ]
          }
        )
      }
    )
  ] })
);
pa.displayName = "ModalBase";
export {
  ge as D,
  pa as M
};
